import Vue from 'vue'
import Router from 'vue-router'
const Login = () => import('@/components/login/Login')
const ForgotPassword = () => import('@/components/forgotPassword/ForgotPassword')
const Home = () => import('@/components/home/Home')
const Select = () => import('@/components/home/select/Select')
const DeliveryMethod = () => import('@/components/home/deliveryMethod/DeliveryMethod')
const AccountDetails = () => import('@/components/home/deliveryMethod/accountDetails/AccountDetails')
const Summary = () => import('@/components/home/summary/Summary')
const TransactionSuccess = () => import('@/components/home/summary/transactionSuccess/TransactionSuccess')
const InteracOnlineSuccess = () => import('@/components/home/summary/interacOnlineSuccess/InteracOnlineSuccess')
const InteracOnlineFailure = () => import('@/components/home/summary/interacOnlineFailure/InteracOnlineFailure')
const TransactionError = () => import('@/components/home/summary/transactionError/TransactionError')
const ETransferInstruction = () => import('@/components/home/summary/eTransferInstruction/ETransferInstruction')
const FundingMethod = () => import('@/components/home/fundingMethod/FundingMethod')
const SenderDetails = () => import('@/components/home/senderDetails/SenderDetails')
const AddBankAccount = () => import('@/components/home/bankAccounts/addBankAccount/AddBankAccount')
const SelectBankAccount = () => import('@/components/home/fundingMethod/selectBankAccount/SelectBankAccount')
const Landing = () => import('@/components/landing/Landing')
const Support = () => import('@/components/support/Support')
const Contact = () => import('@/components/contact2/Contact')
const Privacy = () => import('@/components/privacy/Privacy')
const Sitemap = () => import('@/components/sitemap/Sitemap')
const UserAgreement = () => import('@/components/userAgreement/UserAgreement')
const User = () => import('@/components/user/User')
const EditProfile = () => import('@/components/user/editProfile/EditProfile')
const UserProfile = () => import('@/components/user/userProfile/UserProfile')
const ChangePassword = () => import('@/components/user/changePassword/ChangePassword')
const AutoLogin = () => import('@/components/login/autoLogin/autoLogin')
const ThankYou = () => import('@/components/thankyou/thankyou')
Vue.use(Router)

const router = new Router({
  base: '/',
  mode: 'history',
  hash: true,
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/password/reset',
      name: 'Forgot Password',
      component: ForgotPassword
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      },
      children: [{
        path: 'bank/add',
        name: 'Add Bank',
        component: AddBankAccount
      }]
    },
    {
      path: '/thankyou',
      name: 'Thank you',
      component: ThankYou
    },
    {
      path: '/home',
      name: 'Recipients',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/select',
      name: 'Select',
      component: Select,
      meta: {
        requiresAuth: true,
        requiresSelectRecipient: true
      }
    },
    {
      path: '/home/delivery',
      name: 'Delivery Method',
      component: DeliveryMethod,
      meta: {
        requiresAuth: true,
        requiresRecipient: true
      }
    },
    {
      path: '/recipient/delivery',
      name: 'Delivery Method (Home)',
      component: DeliveryMethod,
      meta: {
        requiresAuth: true,
        requiresRecipient: true
      }
    },
    {
      path: '/home/details',
      name: 'Account Details',
      component: AccountDetails,
      meta: {
        requiresAuth: true,
        requiresRecipient: true
      }
    },
    {
      path: '/home/funding',
      name: 'Funding Method',
      component: FundingMethod,
      meta: {
        requiresAuth: true,
        requiresAccountDetail: true
      },
      children: [
        {
          path: 'bank/add',
          name: 'Add Bank Funding',
          component: AddBankAccount
        },
        {
          path: 'bank/select',
          name: 'Select Bank',
          component: SelectBankAccount
        }
      ]
    },
    {
      path: '/home/summary',
      name: 'Summary',
      component: Summary,
      meta: {
        requiresAuth: true
        // requiresFundingMethod: true
      },
      children: [
        {
          path: 'success',
          name: 'Transaction Success',
          component: TransactionSuccess
        },
        {
          path: 'error',
          name: 'Transaction Error',
          component: TransactionError
        },
        {
          path: 'interac/success',
          name: 'Interac Online Success',
          component: InteracOnlineSuccess
        },
        {
          path: 'interac/failure',
          name: 'Interac Online Failure',
          component: InteracOnlineFailure
        },
        {
          path: 'e-transfer/instruction',
          name: 'ETransfer Instruction',
          component: ETransferInstruction
        }
      ]
    },
    {
      path: '/home/sender',
      name: 'Sender Details',
      component: SenderDetails,
      meta: {
        requiresAuth: true,
        requiresFundingMethod: true
      }
    },
    {
      path: '/help',
      name: 'Support',
      component: Support
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/sitemap',
      name: 'Sitemap',
      component: Sitemap
    },
    {
      path: '/agreement',
      name: 'User Agreement',
      component: UserAgreement
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      children: [
        {
          name: 'Edit profile',
          path: 'update',
          component: EditProfile
        },
        {
          name: 'View profile',
          path: 'view',
          component: UserProfile
        },
        {
          name: 'Change password',
          path: 'change-password',
          component: ChangePassword
        }
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/autoLogin',
      name: 'autoLogin',
      component: AutoLogin
    }
  ]
})
try {
  router.beforeEach((to, from, next) => {
    if (to.matched.some(route => route.meta.requiresAuth)) {
      if (localStorage.getItem('user-auth') && sessionStorage.getItem('vue-session-key')) {
        next()
      } else {
        next({ name: 'Login' })
      }
    } else if (['Login', 'Signup'].includes(to.name)) {
      if (localStorage.getItem('user-auth') && sessionStorage.getItem('vue-session-key')) {
        next(false)
      } else {
        next()
      }
    }
    if (to.matched.some(route => route.meta.requiresSelectRecipient)) {
      if (
        (localStorage.getItem('select-recipient') && localStorage.getItem('select-recipient') !== 'undefined') ||
        (typeof to.params.item === 'object' && to.params.item.hasOwnProperty('key'))
      ) {
        next()
      } else {
        next({ name: 'Home' })
      }
    }
    if (to.matched.some(route => route.meta.requiresRecipient)) {
      if (
        (to.name.includes('Delivery Method') || to.name.includes('Delivery Method (Home)')) &&
        ((!!to.params.item && to.params.item.hasOwnProperty('country')) ||
          (localStorage.getItem('recipient') &&
            localStorage.getItem('recipient') !== 'undefined' &&
            JSON.parse(localStorage.getItem('recipient')).hasOwnProperty(
              'country'
            )))
      ) {
        const country = !!to.params.item && to.params.item.hasOwnProperty('country') && to.params.item.country.length > 2 ? to.params.item.country : !!to.params.item && to.params.item.hasOwnProperty('countryName') ? to.params.item.countryName : JSON.parse(localStorage.getItem('recipient')).countryName
        if (
          !!to.params.item &&
          to.params.item.hasOwnProperty('country') &&
          ['India', 'Philippines', 'Sri Lanka', 'Pakistan', 'China'].includes(country) &&
          !to.params.isRecentRecipient
        ) {
          next()
        } else {
          next({ name: 'Account Details', params: { item: to.params.item, isRecentRecipient: to.params.isRecentRecipient } })
        }
      } else if (
        to.name.includes('Account Details') &&
        !!to.params.item &&
        to.params.item.hasOwnProperty('remittanceGatewayId')
      ) {
        next()
      } else {
        next({ name: 'Select' })
      }
    }
    if (to.matched.some(route => route.meta.requiresAccountDetail)) {
      if (
        localStorage.getItem('recipient') &&
          localStorage.getItem('select-recipient') &&
          localStorage.getItem('recipient') !== 'undefined' &&
          localStorage.getItem('select-recipient') !== 'undefined' &&
          JSON.parse(localStorage.getItem('recipient')).afterAccountDetails
      ) {
        next()
      } else {
        next({ name: 'Select' })
      }
    }
    if (to.matched.some(route => route.meta.requiresFundingMethod)) {
      if (
        ['Summary', 'Funding Method', 'Select Bank'].includes(from.name) &&
        localStorage.getItem('recipient') &&
        localStorage.getItem('select-recipient') &&
        localStorage.getItem('recipient') !== 'undefined' &&
        localStorage.getItem('select-recipient') !== 'undefined'
      ) {
        next()
      } else {
        next({ name: 'Funding Method' })
      }
    }
    if (['Home'].includes(to.name) && ['Home', 'Landing', null].includes(from.name)) {
      localStorage.removeItem('recipient')
    }
    next()
  })
} catch (err) {}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js